<template>
  <div class="page">
    <van-nav-bar title="实习变更" left-arrow @click-left="$router.go(-1)" fixed :placeholder="true" :safe-area-inset-top="true" />
    <div class="empty" v-if="showEmpty">
      <img src="../../../../assets/images/bg_empty.png" alt="" />
      <div>暂无变更申请，是否立即申请？</div>
      <div class="button" @click="newChange()">
        申请变更
      </div>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" v-else style="padding-bottom: 100px">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="change-box" v-for="(item, index) in list" :key="index" @click="routerToDetail">
          <div class="title-line">
            <div class="title">{{item.xm}}提交的实习变更单</div>
            <div class="status" :style="{ borderColor: getStatusColor(item.iswfmes), color: getStatusColor(item.iswfmes) }">{{ getStatusText(item.iswfmes) }}</div>
          </div>
          <div class="date">申请时间: {{item.cjsj}}</div>
          <div class="list">
            <div class="item" v-if="item.ysxqymc != ''">
              <div class="title">单位名称</div>
              <div class="change-item">
                <div class="point"></div>
                <div class="name">{{item.ysxqymc}}</div>
              </div>
              <div class="change-item" style="border-color: #f2f2f4">
                <div class="point" :style="{ backgroundColor: getStatusColor(item.iswfmes) }"></div>
                <div class="name" :style="{ color: getStatusColor(item.iswfmes) }">{{item.sxqymc}}</div>
              </div>
            </div>
            <div class="item" v-if="item.ygwmc != ''">
              <div class="title">岗位名称</div>
              <div class="change-item">
                <div class="point"></div>
                <div class="name">{{item.ygwmc}}</div>
              </div>
              <div class="change-item" style="border-color: #f2f2f4">
                <div class="point" :style="{ backgroundColor: getStatusColor(item.iswfmes) }"></div>
                <div class="name" :style="{ color: getStatusColor(item.iswfmes) }">{{item.gwmc}}</div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <div class="button-box" v-if="!showEmpty">
      <div class="button" @click="newChange()">申请变更</div>
    </div>
  </div>
</template>

<script>
import  iApi  from '@/utils/internship'
import { mapGetters } from 'vuex'
// 实习变更
export default {
  data() {
    return {
      page: 1,
      pageSize: 10,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      showEmpty: false,
    }
  },
  computed: {
    getStatusColor() {
      return status => {
        let color = ['#F85352', '#41B29C', '#FFA400', '#FFA400', '#B2B2B2']
        return color[parseInt(status)]
      }
    },
    getStatusText() {
      return status => {
        let list = ['已拒绝', '已通过', '审核中', '审核中', '已结束']
        return list[parseInt(status)]
      }
    },
    ...mapGetters({
      isty: 'getIsty'
    })
  },
  methods: {
    async onLoad() {
      if (this.refreshing) {
        this.list = []
        this.refreshing = false
      }
      const res = await iApi.getChangeList({
        page: this.page,
        size: this.pageSize,
      })
      this.list = this.list.concat(res.data.list)
      this.list.splice(0,0)
      this.loading = false
      if (res.data.list.length < this.pageSize) {
        this.finished = true
      } else {
        this.page += 1
      }
      if(this,this.list.length == 0){
        this.showEmpty = true
      }
    },
    onRefresh() {
      // 清空列表数据
      this.list = []
      this.page = 1
      this.finished = false

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    },
    newChange(){
      let path
      if(this.isty){
        path = '/internship/uniChange'
      } else {
        path = '/internship/disperseChange'
      }
      this.$router.push({
        path
      })
    },
    routerToDetail(){
      let path
       if(this.isty){
        path = '/internship/applyStatus?config=6'
      } else {
        path = '/internship/applyStatus?config=7'
      }
      this.$router.push({
        path
      })
    }
  },
  created() {
  },
}
</script>

<style lang="less" scoped>
.page {
  min-height: 100vh;
  background: #f2f2f4;
  margin-top: -50px;
}
.empty {
  // margin-top: 167px;
  height: calc(100vh - 46px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 16px;
  color: #666666;
  text-align: center;
  img {
    width: 159px;
    height: 154px;
    margin-bottom: 30px;
  }
  .button {
    width: 232px;
    height: 50px;
    background: #0189f9;
    border-radius: 25px;
    text-align: center;
    line-height: 50px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    margin-top: 50px;
  }
}
.change-box {
  width: 315px;
  min-height: 160px;
  background: #ffffff;
  border-radius: 8px;
  margin: 10px auto;
  padding: 15px;
  .title-line {
    display: flex;
    align-items: center;
    .title {
      // width: 280px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 18px;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .status {
      margin-left: 10px;
      min-width: 46px;
      height: 20px;
      border: 1px solid #41b29c;
      border-radius: 10px;
      text-align: center;
      line-height: 20px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #41b29c;
    }
  }
  .date {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    margin: 5px 0;
  }
  .list {
    width: 291px;
    // min-height: 176px;
    background: #f2f2f4;
    border-radius: 8px;
    padding: 12px;
    padding-bottom: 0;
    .item {
      .title {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        margin-bottom: 15px;
      }
      .change-item {
        margin-left: 6px;
        // margin-top: 10px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        border-left: 2px solid #d8d8d8;
        position: relative;
        height: 30px;
        padding-left: 10px;
        .point {
          width: 6px;
          height: 6px;
          background: #d8d8d8;
          border-radius: 50%;
          position: absolute;
          transform: translate(-50%, -50%);
          left: -1px;
          top: 0px;
        }
        .name {
          line-height: 0px;
        }
      }
    }
  }
}
.button-box {
  width: 375px;
  height: 70px;
  background: #ffffff;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .button {
    width: 345px;
    height: 50px;
    background: #0189f9;
    border-radius: 25px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    line-height: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/changes.vue